import { render, staticRenderFns } from "./VDragSort.vue?vue&type=template&id=23c3d240&scoped=true&"
import script from "./VDragSort.vue?vue&type=script&lang=js&"
export * from "./VDragSort.vue?vue&type=script&lang=js&"
import style0 from "./VDragSort.vue?vue&type=style&index=0&id=23c3d240&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3d240",
  null
  
)

export default component.exports